import Link from './Link';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, Link.extend`
  color: ${theme.colors.action};
  line-height: initial;
  display: inline-block;
  text-decoration: none;
  vertical-align: baseline;
  border-bottom: solid 1px ${theme.colors.action};

  &:hover {
    color: ${theme.colors.actionColor.lighten(0.2)};
    border-color: ${theme.colors.actionColor.lighten(0.2)};
  }

  &:active {
    color: ${theme.colors.actionColor.darken(0.1)};
  }

  ${({ right }) => right && `
    float: right;
  `}
`);



// WEBPACK FOOTER //
// ./src/components/links/ActionLink.js